export const COMMISSIONS_GET = "COMMISSIONS_GET";

export const COMMISSIONS_GET_PENDING = "COMMISSIONS_GET_PENDING";

export const COMMISSIONS_GET_ERROR = "COMMISSIONS_GET_ERROR";

export const COMMISSIONS_GET_SUCCESS = "COMMISSIONS_GET_SUCCESS";

export const COMMITIONS_SAVE = "COMMITIONS_SAVE";

export const COMMOTION_SAVE_PENDING = "COMMOTION_SAVE_PENDING";

export const COMMOTION_SAVE_SUCCESS = "COMMOTION_SAVE_SUCCESS";

export const COMMOTION_SAVE_ERROR = "COMMOTION_SAVE_ERROR";
